import React, { ChangeEvent, Component, useContext, useEffect, useState } from "react";
import IErrorDTO from "../../../../models/DTO/IErrorDTO";
import IFishbowlGetLocationGroupsDTO from "../../../../models/DTO/IFishbowlGetLocationGroupsDTO";
import IFishbowlPullCatalogItemsDTO from "../../../../models/DTO/IFishbowlPullCatalogItemsDTO";
import IOnFishbowlGetLocationGroupsDTO from "../../../../models/DTO/IOnFishbowlGetLocationGroupsDTO";
import IOnFishbowlPullCatalogItemsDTO from "../../../../models/DTO/IOnFishbowlPullCatalogItemsDTO";
import EndpointsEnum from "../../../../models/EndpointsEnum";
import IFishbowlLocation from "../../../../models/Fishbowl/IFishbowlLocation";
import INotification from "../../../../models/INotification";
import IProcessedItemsDetails from "../../../../models/IProcessedItemsDetails";
import ISupplierModel from "../../../../models/ISupplierModel";
import IUserUI from "../../../../models/IUserUI";
import NotificationLevelEnum from "../../../../models/NotificationLevelEnum";
import NotificationPositionEnum from "../../../../models/NotificationPositionEnum";
import OwButton from "../../../shared/OwButton/OwButton";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import OwProcessedItemsDetails from "../../../shared/OwProcessedItemsDetails/OwProcessedItemsDetails";
import OwSelectOption from "../../../shared/OwSelectOption/OwSelectOption";
import OwTitle from "../../../shared/OwTitle/OwTitle";
import "./FishbowlPullCatalogItems.scss";
import * as _ from "lodash-es";
import IFishbowlDownloadCatalogItemsDTO from "../../../../models/DTO/IFishbowlDownloadCatalogItemsDTO";
import IFishbowlOnDownloadCatalogItemsDTO from "../../../../models/DTO/IFishbowlOnDownloadCatalogItemsDTO";
import { Socket } from "socket.io-client";
import IUiSocketSetup from "../../../../models/IUiSocketSetup";
import UserContext from "../../../../contexts/UserContext";
import SupplierContext from "../../../../contexts/SupplierContext";
import { SocketContext } from "../../../../contexts/SocketContext";
import UiContext from "../../../../contexts/UiContext";
import UIService from "../../../../services/UIService";
import ActivityIndicator from "../../../shared/ActivityIndicator/ActivityIndicator";

type Props = {
    closeModalFn: () => void;
    catalogGuid: string;
};

const FishbowlPullCatalogItems = (props: Props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);
    const socket = useContext(SocketContext)!;
    const uiContext = useContext(UiContext);

    const [showProcessedDetails, setShowProcessedDetails] = useState(false);
    const [locations, setLocations] = useState<IFishbowlLocation[]>([]);
    const [locationId, setLocationId] = useState<string | undefined>();
    const [locationGroupId, setLocationGroupId] = useState<string | undefined>();
    const [getLocationsActive, setGetLocationsActive] = useState(true);
    const [pullActive, setPullActive] = useState(false);
    const [processedDetails, setProcessedDetails] = useState<IProcessedItemsDetails>({
        errorDetails: [],
        totalUpdated: 0,
        totalCreated: 0,
        totalErrored: 0,
        totalProcessed: 0,
    });
    const [showConfirm, setShowConfirm] = useState(false);
    const [selectedLocation, setSelectedLocation] = useState<IFishbowlLocation | null>(null);

    const onFishbowlPullItems = (data: IOnFishbowlPullCatalogItemsDTO) => {
        const notification: INotification = {
            message: "successfully_pulled_catalog_items",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        uiContext.notifyFn(null, notification);

        const _processedDetails: IProcessedItemsDetails = {
            totalProcessed: data.totalProcessed,
            totalErrored: data.totalErrors,
            totalCreated: data.totalCreated,
            totalUpdated: data.totalUpdated,
            errorDetails: data.errorDetails,
        };

        setProcessedDetails(_processedDetails);
        setPullActive(false);
        setShowProcessedDetails(true);
    };

    const onGetLocationGroups = (data: IOnFishbowlGetLocationGroupsDTO) => {
        const filteredLocations: IFishbowlLocation[] = data.locations.filter((row) => {
            return row.activeFlag === "true";
        });

        setLocations(filteredLocations);
        setGetLocationsActive(false);
    };

    const onFishbowlDownloadItems = (data: IFishbowlOnDownloadCatalogItemsDTO) => {
        UIService.downloadCSVData(data.csvData, data.filename);
    };

    const sockets: IUiSocketSetup[] = [
        { endpoint: EndpointsEnum.FishbowlOnPullCatalogItems, fn: onFishbowlPullItems },
        { endpoint: EndpointsEnum.FishbowlOnGetLocationGroups, fn: onGetLocationGroups },
        { endpoint: EndpointsEnum.FishbowlOnDownloadCatalogItemsCsv, fn: onFishbowlDownloadItems },
    ];

    useEffect(() => {
        for (const _socket of sockets) {
            socket.on(_socket.endpoint, _socket.fn);
        }

        getLocationGroups();

        return () => {
            for (const _socket of sockets) {
                socket.off(_socket.endpoint, _socket.fn);
            }
        };
    }, []);

    const closeModal = () => {
        props.closeModalFn();
    };

    const dismissProcessedDetails = () => {
        setShowProcessedDetails(false);
    };

    const getLocationGroups = () => {
        const payload: IFishbowlGetLocationGroupsDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
        };

        socket.emit(EndpointsEnum.FishbowlGetLocationGroups, payload);

        setGetLocationsActive(true);
    };

    const pullCatalogItems = () => {
        console.log("pullCatalogItems");

        const catalogGuid = props.catalogGuid;

        const payload: IFishbowlPullCatalogItemsDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            catalogGuid,
        };

        if (locationId && locationId.length && locationGroupId) {
            payload.filterByWarehouse = locationId;
            payload.locationGroupId = locationGroupId;
        }

        console.log("payload: ", payload);

        socket.emit(EndpointsEnum.FishbowlPullCatalogItems, payload);

        setPullActive(true);
    };

    const handleChange = (row: IFishbowlLocation | null) => {
        if (row?.id) {
            setSelectedLocation(row);
            setLocationId(row.id);
            setLocationGroupId(row.locationGroupId);
        } else {
            setSelectedLocation(null);
            setLocationId(undefined);
            setLocationGroupId(undefined);
        }
    };

    const renderLocationTitle = (row: IFishbowlLocation): string => {
        return `${row.LocationGroupName} - ${row.name}`;
    };

    const fishbowlDownloadItems = () => {
        const payload: IFishbowlDownloadCatalogItemsDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
        };

        if (locationId && locationId.length && locationGroupId) {
            payload.filterByWarehouse = locationId;
            payload.locationGroupId = locationGroupId;
        }

        socket.emit(EndpointsEnum.FishbowlDownloadCatalogItemsCsv, payload);
    };

    return (
        <div className={"FishbowlPullCatalogItems p-2"}>
            <div className={"w-100"} style={{ height: "2rem" }}>
                <div className={"d-flex justify-content-between"}>
                    <OwTitle leftIconName={"fad fa-cloud-download-alt"} title={"fishbowl_pull_items"} tag={"h3"} />
                    <div>
                        <OwButton className={"btn-danger"} centerIconClass={"fas fa-times"} fn={closeModal} />
                    </div>
                </div>
            </div>

            {showConfirm ? (
                <div>
                    <div className={"mt-3 mb-3"}>
                        <OwLabel title={"pull_from"} postText={":"} className={"mt-2 me-2"} isBold={true} />
                        {selectedLocation ? `${selectedLocation.LocationGroupName} - ${selectedLocation.name}` : "All Locations"}

                        <div className={"mt-3 mb-3"}>
                            <p>
                                <i className={"fad fa-octagon-exclamation text-danger me-2"} />
                                This process is not reversible, so please double check the above location,
                                <br />
                                that it&#39;s the correct one you want to pull from.
                            </p>
                        </div>

                        <div className={"mt-4"}>
                            <OwButton
                                className={"btn-danger"}
                                title={"back"}
                                fn={() => {
                                    setShowConfirm(false);
                                }}
                            />
                            <OwButton
                                className={"ms-4 btn-primary"}
                                title={"press_and_hold_to_start"}
                                onHold={pullCatalogItems}
                                active={pullActive}
                                disableOnActive={true}
                                holdDelay={3000}
                            />
                        </div>

                        <div className={"mt-5"}>
                            {uiContext.showHiddenFeatures ? <OwButton title={"download_items_csv"} fn={fishbowlDownloadItems} /> : null}
                        </div>
                    </div>
                </div>
            ) : (
                <div>
                    <div className={"mt-3"}>
                        <OwLabel title={"filter_by_location"} />
                        <div>
                            <OwSelectOption
                                titleProp={"name"}
                                valueProp={"id"}
                                titleRenderFn={renderLocationTitle}
                                fn={handleChange}
                                name={"location"}
                                options={locations}
                                isActive={getLocationsActive}
                                isDisabledOnActive={true}
                                showBlankFirst={true}
                                emitObject={true}
                                selectedOption={selectedLocation}
                                selectedOptionProp={"id"}
                            />
                        </div>
                    </div>

                    <div className="mt-3">
                        <OwButton
                            title={"review"}
                            fn={() => {
                                setShowConfirm(true);
                            }}
                        />
                    </div>
                </div>
            )}

            <div>
                {showProcessedDetails ? (
                    <OwProcessedItemsDetails details={processedDetails!} dismissProcessedDetails={dismissProcessedDetails} />
                ) : null}
            </div>
        </div>
    );
};

export default FishbowlPullCatalogItems;
